import { getKeycloak } from "./keycloak";
import { isSessionIdleLocked } from "./sessionIdle";

let refreshIntervalId = null;

export function stopTokenRefreshInterval() {
  if (refreshIntervalId) {
    clearInterval(refreshIntervalId);
    refreshIntervalId = null;
  }
}

/**
 * Periodically refresh the access token while the user is active.
 * Stopped during idle warning so SSO idle timeout can apply.
 */
export function startTokenRefreshInterval(intervalMs = 30000) {
  stopTokenRefreshInterval();
  const kc = getKeycloak();
  if (!kc?.authenticated) {
    return;
  }

  refreshIntervalId = window.setInterval(async () => {
    if (isSessionIdleLocked()) {
      return;
    }
    try {
      await kc.updateToken(60);
      if (kc.token) {
        localStorage.setItem("authToken", kc.token);
      }
    } catch (err) {
      console.error("Background token refresh failed", err);
      stopTokenRefreshInterval();
      localStorage.removeItem("authToken");
      await kc.login({ redirectUri: window.location.href });
    }
  }, intervalMs);
}

export async function refreshSessionNow() {
  const kc = getKeycloak();
  if (!kc?.authenticated) {
    return false;
  }
  await kc.updateToken(-1);
  if (kc.token) {
    localStorage.setItem("authToken", kc.token);
  }
  return true;
}
